import { createSelector } from 'reselect';

const getState = (state) => state.journeyHandling;

const isHandlingOpened = createSelector(getState, (state) => state.opened);

const getOpenedId = createSelector(getState, (state) => state.openedId);

const getSelectedAgent = createSelector(getState, (state) => state.selectedAgent);

const getHandledBy = createSelector(getState, (state) => state.handledBy);

const getIsLoading = createSelector(getState, (state) => state.loading);

export { isHandlingOpened, getOpenedId, getSelectedAgent, getIsLoading, getHandledBy };
